import { type BuildPlatform } from '../../model'

const windowsLogo = 'https://osso.azureedge.net/static/windows.png'
const androidLogo = 'https://osso.azureedge.net/static/android3.png'
const linuxLogo = 'https://osso.azureedge.net/static/linux.png'

export const platformLogo: Record<BuildPlatform, string> = {
  windows: windowsLogo,
  quest: androidLogo,
  linux: linuxLogo
}
